import React, { useState } from "react";
import banner from "../../../assets/kangaroo/ieltsBanner.png";
import SectionContainer from "../../../Homepage/SectionContainer";
import boy from "../../../assets/kangaroo/boyicon.png";
import girl from "../../../assets/kangaroo/girlicon.png";
import writing from "../../../assets/kangaroo/Writing.png";
import speaking from "../../../assets/kangaroo/speaking.png";
import { Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import Button from "../../../component/button/Button";
import Page8 from "../../../Homepage/Map";
import SmallPage from "../../../Homepage/SmallPage";
import "../ielts.css"
import { useParams } from "react-router-dom";
import { data } from "../data.js";
import InlineForm from "../../../component/InlineForm/InlineForm.jsx";
import { link } from "framer-motion/client";
import DynamicInlineForm from "../../../component/DynamicInline/DynamicInlineForm.jsx";

const Ielts = () => {
  const {section} = useParams()
  const item = data[0][section]
  const [thankYouModal, setThankYouModal] = useState(false);
  const toggleThankYou = () => setThankYouModal(!thankYouModal);

  return (
    <>
      <div>
        <img src={banner} className="w-100" fluid alt="" />
      </div>
      <SectionContainer>
        <Container fluid className="p-0">
           <BreadCrumb items={[
    { title: "HOME", link: "/" },
    { title: "TEST PREPARATION", link:"/"  },
    { title: section },
  ]} instituition={true}/>
          <Row>
            <Col>
              <h1 className="font-level-4 mb-4">IELTS PREPARATION</h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="country-paragraph-text" style={{ color: "black" }}>
                International English Language Testing System (IELTS) is one of
                the world’s most trusted and widely recognized English
                proficiency exams. It is designed for individuals aiming to
                study, work, or migrate to countries where English is the
                primary mode of communication - including the UK, Australia,
                Canada, New Zealand, and the United States. <br />
                <br />
                IELTS evaluates four essential language skills:{" "}
                <span className="fw-bold">
                  Listening, Reading, Writing
                </span> and <span className="fw-bold">Speaking</span>, ensuring
                that test takers are fully equipped for academic, professional,
                or everyday environments.
              </p>
            </Col>
          </Row>
          <h1 className=" font-level-8" style={{marginTop:"5.6rem", marginBottom:"3.2rem"}}>
            Detailed Test Structure
          </h1>
         {item?.slice(0, 2).map((elem, index) => (
  <Row key={index}>
    <Col>
      <div className="d-flex flex-column flex-lg-row align-items-center gap-10 mb-5">
        
    
        <div
          className="d-flex justify-content-lg-start justify-content-center align-items-center col-3"
          style={{ flex: "0 0 20%" }}
        >
          <img src={elem.img} className="ielts-img mb-4" alt="" />
        </div>

        <div style={{ flex: "0 0 80%" }}>
          <h1 className="font-level-7">{elem.title}</h1>

          <p className="text-black font-level-6">
            <span className="fw-bold">Duration</span>: {elem.duration}
          </p>

          <p className="text-black font-level-6">
            {elem.description}
          </p>
        </div>

      </div>
    </Col>
  </Row>
))}

        </Container>
      </SectionContainer>
       <SectionContainer mainId="ielts-prep-subpage">
            <Row style={{ marginTop: "6rem" }}>
              <Col>
                <h1 className="font-heading">
                  Start Smart With Expert Test Preparation Classes & Guidance
                </h1>
                <p className="font-desc mt-3 mb-4">
                  Fill in the details below, and our test preparation advisors
                  will guide you toward the right preparation plan and class for
                  your goals.
                </p>
              </Col>
            </Row>

            <DynamicInlineForm
              fullName={true}
              emailAddress={true}
              phoneNumber={true}
              testPrepClasses={true}
              callBackTime={true}
              nearestOffice={true}
              message={true}
            />
            <div className="d-flex justify-content-end">
              <div
                style={{
                  width: "max-content",
                  marginTop: "4rem",
                  marginBottom: "8rem",
                }}
                onClick={toggleThankYou}
              >
                <Button
                  label="BOOK YOUR CLASS"
                  margin="20px 0"
                  width="350.4053px"
                  height="60px"
                  fontSize="22px"
                  fontWeight="500"
                  textColor="#890295"
                  fontFamily="Proxima Nova Bold"
                />
              </div>
            </div>
          </SectionContainer>
      <SectionContainer>
{item?.slice(2).map((elem, index) => (
  <Row key={index} style={{ marginTop: "5.2rem" }}>
    <Col>
      <div className="d-flex flex-column flex-lg-row align-items-center gap-10 mb-5">

        <div
          className="d-flex justify-content-lg-start justify-content-center align-items-center col-3"
          style={{ flex: "0 0 20%" }}
        >
          <img src={elem.img} className="ielts-img mb-4" alt="" />
        </div>

        <div style={{ flex: "0 0 80%" }}>
          <h1 className="font-level-7">{elem.title}</h1>

          <p className="text-black font-level-6">
            <span className="fw-bold">Duration</span>: {elem.duration}
          </p>

          {/* Render description with line breaks and bold Task 1/Task 2 */}
          <div
            className="text-black font-level-6"
            dangerouslySetInnerHTML={{
              __html: elem.description
                .replace(/Task 1:/g, '<strong>Task 1:</strong>')
                .replace(/Task 2:/g, '<strong>Task 2:</strong>')
                 .replace(/1. Introduction & Interview:/g, '<strong>1. Introduction & Interview:</strong>')
                .replace(/2. Long Turn:/g, '<strong>2. Long Turn:</strong>')
                .replace(/3. Discussion:/g, '<strong>3. Discussion:</strong>')
                .replace(/\n/g, '<br />')
            }}
          />
        </div>

      </div>
    </Col>
  </Row>
))}


        <div className="mt-5" style={{marginBottom:"15rem"}}>
          <h1 className="font-level-8 "> More About IELTS</h1>
          <p className="text-black font-level-6">
            {" "}
            <span className="fw-bold">Test Format:</span> Choose between
            Computer-Based or Paper-Based formats{" "}
          </p>
          <p className="text-black font-level-6">
            {" "}
            <span className="fw-bold">Score Validity:</span> Results are valid
            for two yaers
          </p>
          <p className="text-black font-level-6">
            {" "}
            <span className="fw-bold">Global Recognition:</span> Accepted by
            over 10,000 institutions in more than 140 countries, including
            universities, immigration departments, government bodies, and
            professional organizations.
          </p>
        </div>
        <hr className="line" />
        <Page8 />
        <hr className="line-style-testprep" />
        <SmallPage countryPage={true} />
      </SectionContainer>
    </>
  );
};

export default Ielts;
